import { Payload } from "@neworbit/redux-helpers";
import { Dispatch } from "redux";
import axios from "axios";

import { loadAndTrack } from "redux-request-loading";

import { CustomerDetailsApi } from "./CustomerDetailsApi";
import * as actionTypes from "./actionTypes";
import { CustomerDetailsModel } from "./models";

type LoadCustomerDetailsSuccessAction = { type: typeof actionTypes.LOAD_CUSTOMER_DETAILS_SUCCESS } & Payload<CustomerDetailsModel>;

export type CustomerDetailsAction = LoadCustomerDetailsSuccessAction;

function buildLoadCustomerDetails(customerDetailsApi: CustomerDetailsApi) {
    return () => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, actionTypes.LOAD_CUSTOMER_DETAILS, customerDetailsApi.load());
            dispatch(loadCustomerDetailsSuccess(result));
        };
    };
}

export const loadCustomerDetails = buildLoadCustomerDetails(new CustomerDetailsApi(axios));

export function loadCustomerDetailsSuccess(customerDetails: CustomerDetailsModel): LoadCustomerDetailsSuccessAction {
    return {
        type: actionTypes.LOAD_CUSTOMER_DETAILS_SUCCESS,
        payload: customerDetails
    };
}
